import { Button,CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,  } from '@mui/material'
import { trackActivity } from '../../../utils/mixpanel'

const WarningModal = ({invoice,warning,onToggleModal,onProceed,isLoading}) => {
  const handleItemClicked = (page_type) => {
      trackActivity('Item Clicked', { page_title: `${invoice.name}`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="sm"
                fullWidth
                open={warning.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header'>
                   Invoice Warning
                </DialogTitle>
                <DialogContent dividers>
                    {invoice?.invoice_warning_message ?? ""}
                </DialogContent>
                <DialogActions sx={{marginRight: "15px"}}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>Cancel</Button>
                    <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Proceed Button'); onProceed(); }}> {isLoading ? <CircularProgress color='inherit' size={24} /> : "Proceed"} </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default WarningModal;